import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../common/GridLayout";
import {AllowedPageSizes} from '../../../../../const/constants';
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
const ItemSubTab = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const childRef = useRef();
    
    const gridKey = "4335BF09-276E-426B-AF38-8A2F40DAB1F3";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
        }
    };

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                style={{ height: '100%', minHeight: 0 }}
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <ColumnHeaderFilter />
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={25} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={AllowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={false} />
                <FilterPanel visible={false} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                
                <Scrolling mode="virtual" />
                <Column dataField="recordNumber" caption="Record#" />
                <Column dataField="customerCode" caption="Customer" />
                <Column dataField="customerName" caption="Customer Name" />
                <Column dataField="itemCode" caption="Item" visible={false} />
                <Column dataField="description1" caption="Description 1" visible={false} />
                <Column dataField="classCode" caption="Class" />
                <Column dataField="subClassCode" caption="Sub Class" />
                <Column dataField="status" caption="Status" visible={false} />
                <Column dataField="itemType" caption="Item Type" visible={false} />
                <Column dataField="comment" caption="Comment" visible={false} />
                <Column dataField="userdefinedcomment" caption="Comment" visible={false} />
                <Column dataField="description2" caption="Description 2" visible={false} />
                <Column dataField="oemManufacturerCode" caption="OEM Man Code" visible={false} />
                <Column dataField="abccode" caption="ABC Code" visible={false} />
                <Column dataField="statusReasonCode" caption="Reason Code" visible={false} />
                <Column dataField="taxStatus" caption="Tax Status" visible={false} />
                <Column dataField="locationType" caption="Location Type" visible={false} />
                <Column dataField="physicalCountCode" caption="Physical Count Code" visible={false} />
                <Column dataField="freightClassCode" caption="Freight Class Code" visible={false} />
                <Column dataField="inventoryUnitUOM" caption="Inventory Unit UOM" visible={false} />
                <Column dataField="piecesPerUnitUOM" caption="Pieces Per Unit UOM" visible={false} />
                <Column dataField="piecesPerUnitQuantity" caption="Pieces Per Unit Quantity" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="unitsPerPackageUOM" caption="Units Per Package UOM" visible={false} />
                <Column dataField="unitsPerPackageQuantity" caption="Units Per Package Quantity" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="arTradeDiscountFlag" caption="AR Trade Disc Flag" visible={false} />
                <Column dataField="packagesPerShippingUnitUOM" caption="Packages Per Shipping Unit UOM" visible={false} />
                <Column dataField="arTermsDiscountFlag" caption="AR Terms Disc Flag" visible={false} />
                <Column dataField="packagesPerShippingUnitQty" caption="Packages Per Shipping Unit Quantity" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="saleIncrementQuantity" caption="Sale Increment" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="unitVolumeUOM" caption="Unit Volume UOM" visible={false} />
                <Column dataField="minimumSalesQuantity" caption="Minimum Qty" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="unitVolumeQuantity" caption="Unit Volume Quantity" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="unitAreaUOM" caption="Unit Area UOM" visible={false} />
                <Column dataField="unitAreaQuantity" caption="Unit Area Quantity" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="unitValueUOM" caption="Unit Value UOM" visible={false} />
                <Column dataField="unitValueQuantity" caption="Unit Value Quantity" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="weightBasisFlag" caption="Weight Basis Flag" visible={false} />
                <Column dataField="netWeightUOM" caption="Net Weight UOM" visible={false} />
                <Column dataField="netWeightQuantity" caption="Net Weight Qty" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="grossWeightUOM" caption="Gross Weight UOM" visible={false} />
                <Column dataField="grossWeightQuantity" caption="Gross Weight Qty" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="vendorItemCode" caption="Vendor Item Code" visible={false} />
                <Column dataField="receiptUOMDefault" caption="Receipt UOM Default" visible={false} />
                <Column dataField="receiptUOMMultiple" caption="Receipt UOM Multiple" visible={false} />
                <Column dataField="receiptUOMAlternative" caption="Receipt UOM Alternative" visible={false} />
                <Column dataField="receiptPackSize" caption="Receipt Pack Size" visible={false} />
                <Column dataField="shipmentUOMDefault" caption="Shipment UOM Default" visible={false} />
                <Column dataField="shipmentUOMMultiple" caption="Shipment UOM Multiple" visible={false} />
                <Column dataField="shipmentUOMAlternative" caption="Shipment UOM Alternative" visible={false} />
                <Column dataField="shipmentPackSize" caption="Shipment Pack Size" visible={false} />
                <Column dataField="shipSelection" caption="Ship Selection" visible={false} />
                <Column dataField="stackHeight" caption="Stack Height" visible={false} dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} />
                <Column dataField="palletPatternRow" caption="Pallet Pattern Row" visible={false} />
                <Column dataField="palletPatternColumn" caption="Pallet Pattern Column" visible={false} />
                <Column dataField="palletPatternHeight" caption="Pallet Pattern Height" visible={false} />
                <Column dataField="palletSizeCode" caption="Pallet Size Code" visible={false} />
                <Column dataField="boxCode" caption="Box Code" visible={false} />
                <Column dataField="hazardousFlag" caption="Hazard Flag" visible={false} />
                <Column dataField="careInstructions" caption="Care Instruct" visible={false} />
                <Column dataField="specificationCode" caption="Specification Code" visible={false} />
                <Column dataField="itemSupCode" caption="Item Supplier Code" visible={false} />
                <Column dataField="bomExplosionFlag" caption="BOM Exp Flag" visible={false} />
                <Column dataField="miscellaneousFeeFlag" caption="Misc Fee Flag" visible={false} />
                <Column dataField="storageLocationType" caption="Location Type" visible={false} />
                <Column dataField="storageLocationPriorityFlag" caption="Storage Location Priority Flag" visible={false} />
                <Column dataField="systemCode" caption="System Code" visible={false} />
                <Column dataField="assemblyCode" caption="Assembly Code" visible={false} />
                <Column dataField="partCode" caption="Part Code" visible={false} />
                <Column dataField="emCostBucketNumber" caption="EM Cost Bucket No" visible={false} />
                <Column dataField="tlFuelTaxFlag" caption="TL Fuel Tax Flag" visible={false} />
                <Column dataField="tlFuelTaxCode" caption="TL Fuel Tax Code" visible={false} />
                <Column dataField="dateIntroduced" caption="Date Intro" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="dateAvailable" caption="Date Avail" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="dateExpiration" caption="Date Exp" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="storageBillingStartDate" caption="Storage Billing Start Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="storageBillingStartDate" caption="Storage Billing Start Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="creationDate" caption="Creation Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="lastUpdatedDate" caption="Last Updated Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="storageBillingEndDate" caption="Storage Billing End Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="itemSourceFlag" caption="Item Source Flag" visible={false} />
                <Column dataField="reorderMethodFlag" caption="Reorder Method Flag" visible={false} />
                <Column dataField="createdBy" caption="Created By" visible={false} />
                <Column dataField="lastUpdatedBy" caption="Last Updated By" visible={false} />
                <Column dataField="reorderInventoryMinimumQty" caption="ReorderInv Min Qty" dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} visible={false} />
                <Column dataField="reorderInventoryMaximumQty" caption="Reorder Inv Max Qty" dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} visible={false} />
                <Column dataField="reorderMinimumDaysOnHand" caption="Reorder Minimum Days On Hand" visible={false} />
                <Column dataField="reorderMaximumDaysOnHand" caption="Reorder Maximum Days On Hand" visible={false} />
                <Column dataField="reorderQuantityEOQCalculated" caption="Reorder Quantity EOQ Calculated" dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} visible={false} />
                <Column dataField="reorderQuantityEntered" caption="Reorder Quantity Entered" dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} visible={false} />
                <Column dataField="reorderQuantityOrderMultiple" caption="Reorder Quantity Order Multiple" dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} visible={false} />
                <Column dataField="reorderSafetyQuantity" caption="Reorder Safety Quantity" dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} visible={false} />
                <Column dataField="reorderLeadTime" caption="Reorder Lead Time" visible={false} />
                <Column dataField="costBasisMethodFlag" caption="Cost Basis" visible={false} />
                <Column dataField="averageCost" caption="Average Cost" dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} visible={false} />
                <Column dataField="standardCost" caption="Standard Cost" dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} visible={false} />
                <Column dataField="corePrice" caption="Core Price" dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} visible={false} />
                <Column dataField="maximumPriceLevelForDiscount" caption="Max Price Level For Disc" visible={false} />
                <Column dataField="anniversaryBillingFlag" caption="Anniver Bill Flag" visible={false} />
                <Column dataField="anniversaryBillingDate" caption="Anniver BillDate" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="anniversaryBillingQuantity" caption="Anniver Bill Qty" dataType="number" format={{
                    type: 'fixedPoint',
                    precision: 2,
                    useGrouping: true
                }} visible={false} />
                <Column dataField="warrantyFlag" caption="Warranty Flag" visible={false} />
                <Column dataField="warrantyPeriodTypeFlag" caption="Warranty Period Type Flag" visible={false} />
                <Column dataField="warrantyMonths" caption="Warranty Months" visible={false} />
                <Column dataField="warrantyMeterMiles" caption="Warranty Meter Miles" visible={false} />
                <Column dataField="warrantyMeterHours" caption="Warranty Meter Hours" visible={false} />
                <Column dataField="userDefinedCode1" caption="Code 1" visible={false} />
                <Column dataField="userDefinedCode2" caption="Code 2" visible={false} />
                <Column dataField="userDefinedCode3" caption="Code 3" visible={false} />
                <Column dataField="userDefinedCode4" caption="Code 4" visible={false} />
                <Column dataField="userDefinedCode5" caption="Code 5" visible={false} />
                <Column dataField="userDefinedCode6" caption="Code 6" visible={false} />
                <Column dataField="userDefinedCode7" caption="Code 7" visible={false} />
                <Column dataField="userDefinedCode8" caption="Code 8" visible={false} />
                <Column dataField="userDefinedCode9" caption="Code 9" visible={false} />
                <Column dataField="userDefinedCode10" caption="Code 10" visible={false} />

                <Column dataField="userDefinedReference1" caption="Reference 1" visible={false} />
                <Column dataField="userDefinedReference2" caption="Reference 2" visible={false} />
                <Column dataField="userDefinedReference3" caption="Reference 3" visible={false} />
                <Column dataField="userDefinedReference4" caption="Reference 4" visible={false} />
                <Column dataField="userDefinedReference5" caption="Reference 5" visible={false} />
                <Column dataField="userDefinedReference6" caption="Reference 6" visible={false} />
                <Column dataField="userDefinedReference7" caption="Reference 7" visible={false} />
                <Column dataField="userDefinedReference8" caption="Reference 8" visible={false} />
                <Column dataField="userDefinedReference9" caption="Reference 9" visible={false} />
                <Column dataField="userDefinedReference10" caption="Reference 10" visible={false} />

                <Column dataField="userDefinedDate1" caption="Date 1" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="userDefinedDate2" caption="Date 2" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="userDefinedDate3" caption="Date 3" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="userDefinedDate4" caption="Date 4" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="userDefinedDate5" caption="Date 5" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="userDefinedDate6" caption="Date 6" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="userDefinedDate7" caption="Date 7" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="userDefinedDate8" caption="Date 8" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="userDefinedDate9" caption="Date 9" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="userDefinedDate10" caption="Date 10" visible={false} dataType="date" format="MM/dd/yyyy" />

                <Column dataField="userDefinedQuantity1" caption="Quantity 1" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="userDefinedQuantity2" caption="Quantity 2" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="userDefinedQuantity3" caption="Quantity 3" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="userDefinedQuantity4" caption="Quantity 4" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="userDefinedQuantity5" caption="Quantity 5" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="userDefinedQuantity6" caption="Quantity 6" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="userDefinedQuantity7" caption="Quantity 7" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="userDefinedQuantity8" caption="Quantity 8" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="userDefinedQuantity9" caption="Quantity 9" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="userDefinedQuantity10" caption="Quantity 10" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />

                <Column dataField="volumeAvailable" caption="Volume Available" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="areaAvailable" caption="Area Available" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="valueAvailable" caption="Value Available" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="netWeightAvailable" caption="Net Weight Available" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="grossWeightAvailable" caption="Gross Weight Available" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="onHand" caption="On Hand" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="available" caption="Available" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <Column dataField="netAvailable" caption="Net Available" visible={false} dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />

                <Column dataField="department" caption="Department" visible={false} />
                <Column dataField="departmentDescription" caption="Department Description" visible={false} />
                <Column dataField="fund" caption="Fund" visible={false} />
                <Column dataField="fundDescription" caption="Fund Description" visible={false} />
                <Column dataField="job" caption="Job" visible={false} />
                <Column dataField="jobDescription" caption="Job Description" visible={false} />
                <Toolbar>

                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ItemSubTab);